import { useState } from "react";
import {
  Box,
  Typography,

  Paper,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Chip,
  Grid,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import Layout from "../components/layout/Calayout";

const PeriodicAuditsPage = () => {
  const [openDetailsDialog, setOpenDetailsDialog] = useState(false);
  const [selectedAudit, setSelectedAudit] = useState(null);

  // Sample audit data - replace with your actual data source
  const auditData = [
    {
      id: 1,
      auditPeriod: "Q1 2024",
      status: "Completed",
      startDate: "2024-01-01",
      endDate: "2024-03-31",
      reportLink: "/reports/q1-2024-audit.pdf",
      findings: 3,
    },
    {
      id: 2,
      auditPeriod: "Q2 2024",
      status: "In Progress",
      startDate: "2024-04-01",
      endDate: "2024-06-30",
      reportLink: null,
      findings: 1,
    },
    {
      id: 3,
      auditPeriod: "Q3 2024",
      status: "Scheduled",
      startDate: "2024-07-01",
      endDate: "2024-09-30",
      reportLink: null,
      findings: 0,
    },
  ];

  const getStatusColor = (status) => {
    switch (status) {
      case "Completed":
        return "success";
      case "In Progress":
        return "warning";
      case "Scheduled":
        return "default";
      default:
        return "default";
    }
  };

  const columns = [
    {
      field: "auditPeriod",
      headerName: "Audit Period",
      flex: 1,
    },
    {
      field: "status",
      headerName: "Status",
      flex: 1,
      renderCell: (params) => (
        <Chip
          label={params.value}
          color={getStatusColor(params.value)}
          variant="outlined"
        />
      ),
    },
    {
      field: "startDate",
      headerName: "Start Date",
      flex: 1,
    },
    {
      field: "endDate",
      headerName: "End Date",
      flex: 1,
    },
    {
      field: "findings",
      headerName: "Findings",
      flex: 1,
    },
    {
      field: "actions",
      headerName: "Actions",
      flex: 1,
      renderCell: (params) => (
        <Box>
          <Button
            variant="outlined"
            color="primary"
            size="small"
            onClick={() => {
              setSelectedAudit(params.row);
              setOpenDetailsDialog(true);
            }}
          >
            View Details
          </Button>
          {params.row.reportLink && (
            <Button
              variant="outlined"
              color="secondary"
              size="small"
              sx={{ ml: 1 }}
              href={params.row.reportLink}
              target="_blank"
            >
              Download Report
            </Button>
          )}
        </Box>
      ),
    },
  ];

  const handleCloseDetailsDialog = () => {
    setOpenDetailsDialog(false);
    setSelectedAudit(null);
  };

  return (
    <Layout>
      <Box sx={{ width: "100%", p: 3 }}>
        <Typography variant="h4" gutterBottom>
          Periodic Audits
        </Typography>

        <Paper sx={{ width: "100%", mb: 2 }}>
          <DataGrid
            rows={auditData}
            columns={columns}
            pageSize={5}
            rowsPerPageOptions={[5]}
            checkboxSelection
            disableSelectionOnClick
            autoHeight
          />
        </Paper>

        {/* Audit Details Dialog */}
        <Dialog
          open={openDetailsDialog}
          onClose={handleCloseDetailsDialog}
          maxWidth="md"
          fullWidth
        >
          <DialogTitle>Audit Details: {selectedAudit?.auditPeriod}</DialogTitle>
          <DialogContent>
            {selectedAudit && (
              <Grid container spacing={2}>
                <Grid item xs={12} md={6}>
                  <Typography variant="subtitle1">Basic Information</Typography>
                  <Typography>Status: {selectedAudit.status}</Typography>
                  <Typography>Start Date: {selectedAudit.startDate}</Typography>
                  <Typography>End Date: {selectedAudit.endDate}</Typography>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Typography variant="subtitle1">Audit Findings</Typography>
                  <Typography>
                    Total Findings: {selectedAudit.findings}
                  </Typography>
                  {/* You can expand this with more detailed findings */}
                </Grid>
              </Grid>
            )}
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseDetailsDialog} color="primary">
              Close
            </Button>
          </DialogActions>
        </Dialog>
      </Box>
    </Layout>
  );
};

export default PeriodicAuditsPage;
